/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../common";
import type { ProxyFactory, ProxyFactoryInterface } from "../ProxyFactory";

const _abi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "weth_",
        type: "address",
        internalType: "address",
      },
      {
        name: "usdc_",
        type: "address",
        internalType: "address",
      },
      {
        name: "liquidityPool",
        type: "address",
        internalType: "address",
      },
      {
        name: "sequencer_",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "fallback",
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "afterOrderCancellation",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "order",
        type: "tuple",
        internalType: "struct IOrder.Props",
        components: [
          {
            name: "addresses",
            type: "tuple",
            internalType: "struct IOrder.Addresses",
            components: [
              {
                name: "account",
                type: "address",
                internalType: "address",
              },
              {
                name: "receiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "cancellationReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "callbackContract",
                type: "address",
                internalType: "address",
              },
              {
                name: "uiFeeReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "market",
                type: "address",
                internalType: "address",
              },
              {
                name: "initialCollateralToken",
                type: "address",
                internalType: "address",
              },
              {
                name: "swapPath",
                type: "address[]",
                internalType: "address[]",
              },
            ],
          },
          {
            name: "numbers",
            type: "tuple",
            internalType: "struct IOrder.Numbers",
            components: [
              {
                name: "orderType",
                type: "uint8",
                internalType: "enum IOrder.OrderType",
              },
              {
                name: "decreasePositionSwapType",
                type: "uint8",
                internalType: "enum IOrder.DecreasePositionSwapType",
              },
              {
                name: "sizeDeltaUsd",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "initialCollateralDeltaAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "triggerPrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "acceptablePrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "executionFee",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "callbackGasLimit",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "minOutputAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "updatedAtTime",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "validFromTime",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "flags",
            type: "tuple",
            internalType: "struct IOrder.Flags",
            components: [
              {
                name: "isLong",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "shouldUnwrapNativeToken",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "isFrozen",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "autoCancel",
                type: "bool",
                internalType: "bool",
              },
            ],
          },
        ],
      },
      {
        name: "",
        type: "tuple",
        internalType: "struct IEvent.EventLogData",
        components: [
          {
            name: "addressItems",
            type: "tuple",
            internalType: "struct IEvent.AddressItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.AddressKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address",
                    internalType: "address",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.AddressArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address[]",
                    internalType: "address[]",
                  },
                ],
              },
            ],
          },
          {
            name: "uintItems",
            type: "tuple",
            internalType: "struct IEvent.UintItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.UintKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.UintArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256[]",
                    internalType: "uint256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "intItems",
            type: "tuple",
            internalType: "struct IEvent.IntItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.IntKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256",
                    internalType: "int256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.IntArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256[]",
                    internalType: "int256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "boolItems",
            type: "tuple",
            internalType: "struct IEvent.BoolItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BoolKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool",
                    internalType: "bool",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BoolArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool[]",
                    internalType: "bool[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytes32Items",
            type: "tuple",
            internalType: "struct IEvent.Bytes32Items",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32KeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32",
                    internalType: "bytes32",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32ArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32[]",
                    internalType: "bytes32[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytesItems",
            type: "tuple",
            internalType: "struct IEvent.BytesItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BytesKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes",
                    internalType: "bytes",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BytesArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes[]",
                    internalType: "bytes[]",
                  },
                ],
              },
            ],
          },
          {
            name: "stringItems",
            type: "tuple",
            internalType: "struct IEvent.StringItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.StringKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string",
                    internalType: "string",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.StringArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string[]",
                    internalType: "string[]",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "afterOrderExecution",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "order",
        type: "tuple",
        internalType: "struct IOrder.Props",
        components: [
          {
            name: "addresses",
            type: "tuple",
            internalType: "struct IOrder.Addresses",
            components: [
              {
                name: "account",
                type: "address",
                internalType: "address",
              },
              {
                name: "receiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "cancellationReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "callbackContract",
                type: "address",
                internalType: "address",
              },
              {
                name: "uiFeeReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "market",
                type: "address",
                internalType: "address",
              },
              {
                name: "initialCollateralToken",
                type: "address",
                internalType: "address",
              },
              {
                name: "swapPath",
                type: "address[]",
                internalType: "address[]",
              },
            ],
          },
          {
            name: "numbers",
            type: "tuple",
            internalType: "struct IOrder.Numbers",
            components: [
              {
                name: "orderType",
                type: "uint8",
                internalType: "enum IOrder.OrderType",
              },
              {
                name: "decreasePositionSwapType",
                type: "uint8",
                internalType: "enum IOrder.DecreasePositionSwapType",
              },
              {
                name: "sizeDeltaUsd",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "initialCollateralDeltaAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "triggerPrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "acceptablePrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "executionFee",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "callbackGasLimit",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "minOutputAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "updatedAtTime",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "validFromTime",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "flags",
            type: "tuple",
            internalType: "struct IOrder.Flags",
            components: [
              {
                name: "isLong",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "shouldUnwrapNativeToken",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "isFrozen",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "autoCancel",
                type: "bool",
                internalType: "bool",
              },
            ],
          },
        ],
      },
      {
        name: "data",
        type: "tuple",
        internalType: "struct IEvent.EventLogData",
        components: [
          {
            name: "addressItems",
            type: "tuple",
            internalType: "struct IEvent.AddressItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.AddressKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address",
                    internalType: "address",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.AddressArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address[]",
                    internalType: "address[]",
                  },
                ],
              },
            ],
          },
          {
            name: "uintItems",
            type: "tuple",
            internalType: "struct IEvent.UintItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.UintKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.UintArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256[]",
                    internalType: "uint256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "intItems",
            type: "tuple",
            internalType: "struct IEvent.IntItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.IntKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256",
                    internalType: "int256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.IntArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256[]",
                    internalType: "int256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "boolItems",
            type: "tuple",
            internalType: "struct IEvent.BoolItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BoolKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool",
                    internalType: "bool",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BoolArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool[]",
                    internalType: "bool[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytes32Items",
            type: "tuple",
            internalType: "struct IEvent.Bytes32Items",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32KeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32",
                    internalType: "bytes32",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32ArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32[]",
                    internalType: "bytes32[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytesItems",
            type: "tuple",
            internalType: "struct IEvent.BytesItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BytesKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes",
                    internalType: "bytes",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BytesArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes[]",
                    internalType: "bytes[]",
                  },
                ],
              },
            ],
          },
          {
            name: "stringItems",
            type: "tuple",
            internalType: "struct IEvent.StringItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.StringKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string",
                    internalType: "string",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.StringArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string[]",
                    internalType: "string[]",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "afterOrderFrozen",
    inputs: [
      {
        name: "key",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "",
        type: "tuple",
        internalType: "struct IOrder.Props",
        components: [
          {
            name: "addresses",
            type: "tuple",
            internalType: "struct IOrder.Addresses",
            components: [
              {
                name: "account",
                type: "address",
                internalType: "address",
              },
              {
                name: "receiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "cancellationReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "callbackContract",
                type: "address",
                internalType: "address",
              },
              {
                name: "uiFeeReceiver",
                type: "address",
                internalType: "address",
              },
              {
                name: "market",
                type: "address",
                internalType: "address",
              },
              {
                name: "initialCollateralToken",
                type: "address",
                internalType: "address",
              },
              {
                name: "swapPath",
                type: "address[]",
                internalType: "address[]",
              },
            ],
          },
          {
            name: "numbers",
            type: "tuple",
            internalType: "struct IOrder.Numbers",
            components: [
              {
                name: "orderType",
                type: "uint8",
                internalType: "enum IOrder.OrderType",
              },
              {
                name: "decreasePositionSwapType",
                type: "uint8",
                internalType: "enum IOrder.DecreasePositionSwapType",
              },
              {
                name: "sizeDeltaUsd",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "initialCollateralDeltaAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "triggerPrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "acceptablePrice",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "executionFee",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "callbackGasLimit",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "minOutputAmount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "updatedAtTime",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "validFromTime",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "flags",
            type: "tuple",
            internalType: "struct IOrder.Flags",
            components: [
              {
                name: "isLong",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "shouldUnwrapNativeToken",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "isFrozen",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "autoCancel",
                type: "bool",
                internalType: "bool",
              },
            ],
          },
        ],
      },
      {
        name: "",
        type: "tuple",
        internalType: "struct IEvent.EventLogData",
        components: [
          {
            name: "addressItems",
            type: "tuple",
            internalType: "struct IEvent.AddressItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.AddressKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address",
                    internalType: "address",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.AddressArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "address[]",
                    internalType: "address[]",
                  },
                ],
              },
            ],
          },
          {
            name: "uintItems",
            type: "tuple",
            internalType: "struct IEvent.UintItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.UintKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.UintArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "uint256[]",
                    internalType: "uint256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "intItems",
            type: "tuple",
            internalType: "struct IEvent.IntItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.IntKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256",
                    internalType: "int256",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.IntArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "int256[]",
                    internalType: "int256[]",
                  },
                ],
              },
            ],
          },
          {
            name: "boolItems",
            type: "tuple",
            internalType: "struct IEvent.BoolItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BoolKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool",
                    internalType: "bool",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BoolArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bool[]",
                    internalType: "bool[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytes32Items",
            type: "tuple",
            internalType: "struct IEvent.Bytes32Items",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32KeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32",
                    internalType: "bytes32",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.Bytes32ArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes32[]",
                    internalType: "bytes32[]",
                  },
                ],
              },
            ],
          },
          {
            name: "bytesItems",
            type: "tuple",
            internalType: "struct IEvent.BytesItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.BytesKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes",
                    internalType: "bytes",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.BytesArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "bytes[]",
                    internalType: "bytes[]",
                  },
                ],
              },
            ],
          },
          {
            name: "stringItems",
            type: "tuple",
            internalType: "struct IEvent.StringItems",
            components: [
              {
                name: "items",
                type: "tuple[]",
                internalType: "struct IEvent.StringKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string",
                    internalType: "string",
                  },
                ],
              },
              {
                name: "arrayItems",
                type: "tuple[]",
                internalType: "struct IEvent.StringArrayKeyValue[]",
                components: [
                  {
                    name: "key",
                    type: "string",
                    internalType: "string",
                  },
                  {
                    name: "value",
                    type: "string[]",
                    internalType: "string[]",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "createProxy",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "collateralToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "assetToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "isLong",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "editNumberOfOpenPositions",
    inputs: [
      {
        name: "decreaseNum",
        type: "bool",
        internalType: "bool",
      },
      {
        name: "proxy",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "forceCloseOpenPositions",
    inputs: [
      {
        name: "_numberOfPositionsToClose",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "ordersSent",
        type: "bytes32[]",
        internalType: "bytes32[]",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "getConfigVersions",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "assetToken",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "projectConfigVersion",
        type: "uint32",
        internalType: "uint32",
      },
      {
        name: "assetConfigVersion",
        type: "uint32",
        internalType: "uint32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getProjectAssetConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "assetToken",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getProjectConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getProxiesOf",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getProxy",
    inputs: [
      {
        name: "accountKey",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getProxyAddress",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "collateralToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "assetToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "isLong",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getProxyProjectId",
    inputs: [
      {
        name: "proxy_",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "implementation",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isEpochFinished",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "isKeeper",
    inputs: [
      {
        name: "keeper",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "minimumSizeUSD",
    inputs: [],
    outputs: [
      {
        name: "size",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "multicall",
    inputs: [
      {
        name: "proxyCalls",
        type: "bytes[]",
        internalType: "bytes[]",
      },
    ],
    outputs: [
      {
        name: "results",
        type: "bytes[]",
        internalType: "bytes[]",
      },
    ],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "numberOfOpenPositions",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "paused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "proxyFunctionCall",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IProxyFactory.ProxyCallParams",
        components: [
          {
            name: "projectId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "assetToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "isLong",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "referralCode",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "proxyCallData",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "bytesReturned",
        type: "bytes",
        internalType: "bytes",
      },
      {
        name: "proxyAddress",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "rewardsLimit",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "setDistributorFee",
    inputs: [
      {
        name: "_fee",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setEpochBuffer",
    inputs: [
      {
        name: "_buffer",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setEpochDuration",
    inputs: [
      {
        name: "_duration",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setKeeper",
    inputs: [
      {
        name: "keeper",
        type: "address",
        internalType: "address",
      },
      {
        name: "enable",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setMaintainer",
    inputs: [
      {
        name: "maintainer",
        type: "address",
        internalType: "address",
      },
      {
        name: "enable",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setMaxTotalReward",
    inputs: [
      {
        name: "_totalReward",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setMinimumSizeUSD",
    inputs: [
      {
        name: "_minimumSize",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setPriceFeed",
    inputs: [
      {
        name: "token",
        type: "address",
        internalType: "address",
      },
      {
        name: "priceFeed",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setPrizeRatios",
    inputs: [
      {
        name: "_prizeRatio",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setProjectAssetConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "assetToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "values",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setProjectConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "values",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setProtocolFee",
    inputs: [
      {
        name: "_fee",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setReferralManager",
    inputs: [
      {
        name: "referralManager",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setSequencerAddress",
    inputs: [
      {
        name: "sequencer_",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setUniPoolFee",
    inputs: [
      {
        name: "_fee",
        type: "uint24",
        internalType: "uint24",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "simulateProxyFunctionCall",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IProxyFactory.ProxyCallParams",
        components: [
          {
            name: "projectId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "assetToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "isLong",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "referralCode",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "proxyCallData",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "bytesReturned",
        type: "bytes",
        internalType: "bytes",
      },
      {
        name: "proxyAddress",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferToken",
    inputs: [
      {
        name: "toOrderVault",
        type: "address",
        internalType: "address",
      },
      {
        name: "collateralToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "upgradeTo",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "newImplementation_",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "usdc",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "viewCurrentEpoch",
    inputs: [],
    outputs: [
      {
        name: "startTime",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "endTime",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "totalReward",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "totalCollateral",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "currentEpochId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "viewEpochContenders",
    inputs: [],
    outputs: [
      {
        name: "contenders",
        type: "tuple[]",
        internalType: "struct Storage.Contender[]",
        components: [
          {
            name: "pnl",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "collateral",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "roi",
            type: "int256",
            internalType: "int256",
          },
          {
            name: "owner",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "viewPositions",
    inputs: [],
    outputs: [
      {
        name: "numberOfPositions",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "viewWinForeverRewards",
    inputs: [],
    outputs: [
      {
        name: "rewards",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "weth",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "withdrawWinForeverRewards",
    inputs: [
      {
        name: "to",
        type: "address",
        internalType: "address",
      },
      {
        name: "token",
        type: "address",
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "CreateProxy",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "proxyId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "owner",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "proxy",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "gmxPositionKey",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "assetToken",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "collateralToken",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "collateralTokenId",
        type: "uint8",
        indexed: false,
        internalType: "uint8",
      },
      {
        name: "isLong",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "DisableBorrowConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "assetToken",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "MuxCall",
    inputs: [
      {
        name: "target",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "data",
        type: "bytes",
        indexed: false,
        internalType: "bytes",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetBorrowConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "assetToken",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "prevAssetId",
        type: "uint8",
        indexed: false,
        internalType: "uint8",
      },
      {
        name: "newAssetId",
        type: "uint8",
        indexed: false,
        internalType: "uint8",
      },
      {
        name: "prevLimit",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "newLimit",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetKeeper",
    inputs: [
      {
        name: "keeper",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "enable",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetLiquiditySource",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "sourceId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "source",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetMaintainer",
    inputs: [
      {
        name: "maintainer",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "enable",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetProjectAssetConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "assetToken",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "values",
        type: "uint256[]",
        indexed: false,
        internalType: "uint256[]",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetProjectConfig",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "values",
        type: "uint256[]",
        indexed: false,
        internalType: "uint256[]",
      },
      {
        name: "version",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Unpaused",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [
      {
        name: "projectId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "implementation",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
] as const;

const _bytecode =
  "0x6080346200017357601f6200615e38819003918201601f19168301916001600160401b03831184841017620001785780849260809460405283398101031262000173576200004d816200018e565b906200005c602082016200018e565b9062000079606062000071604084016200018e565b92016200018e565b601f80546001600160a81b0319811633600881811b610100600160a81b031692909217938490556040516001600160a01b0397959690958894919385939192901c83167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0600080a38160018060a01b031999168960195416176019551687601a541617601a551685601654161760165583339160081c16036200013157501690601b541617601b55604051615fba9081620001a48239f35b62461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606490fd5b600080fd5b634e487b7160e01b600052604160045260246000fd5b51906001600160a01b0382168203620001735756fe608060405260043610156200001b575b6200001962005845565b005b60003560e01c80630a7dc31c14620004bb5780630cc006f314620004b05780630f74f4d214620004a557806314863ee9146200049a57806323932363146200048f57806324dca2171462000484578063286e9a9e14620004795780632c0a1540146200046e57806330024dfe14620004635780633ad06d1614620004585780633e413bee146200044d5780633e65196f14620004425780633f01549b14620004375780633f4ba83a146200042c5780633fc8cef314620004215780634663704f146200041657806349158bd1146200040b5780634cda995d14620004005780635026f39b14620003f5578063580f54ba14620003ea5780635c60da1b14620003df5780635c975abb14620003d4578063615b891a14620002ed5780636ba42aaa14620003c95780636c2643a014620003be5780636d7b690614620003b3578063715018a614620003a857806375673bcf146200039d57806376e112861462000392578063787dce3d14620003875780637d0fc993146200037c57806382d04e3314620003715780638456cb5914620003665780638947175b146200035b5780638b9e55dc14620003505780638da5cb5b14620003455780639d0b89c0146200033a578063ac9650d8146200032f578063b1a614891462000324578063b6e6096d1462000319578063c2d86444146200030e578063c3e34c1d1462000303578063c5f3a4c414620002f8578063cf8c94f314620002ed578063d1b9e85314620002e2578063d3d3206d14620002d7578063d5cb711b14620002cc578063e0d27c2a14620002c1578063f0c0897514620002b6578063f2fde38b14620002ab578063f5537ede14620002a05763faafd8e5036200000f576200029a620031cc565b6200000f565b506200029a6200311a565b506200029a6200303a565b506200029a62002ea0565b506200029a62002e32565b506200029a62002ddd565b506200029a62002dba565b506200029a62002d4f565b506200029a620012a3565b506200029a62002d01565b506200029a62002c23565b506200029a62002b57565b506200029a62002b23565b506200029a62002aa0565b506200029a62002991565b506200029a62002844565b506200029a620027ce565b506200029a6200279c565b506200029a620017cc565b506200029a6200176b565b506200029a6200174a565b506200029a62001618565b506200029a620015ac565b506200029a6200153c565b506200029a62001505565b506200029a6200149e565b506200029a62001366565b506200029a6200130b565b506200029a620012c4565b506200029a6200127d565b506200029a620011f5565b506200029a620011cf565b506200029a6200118d565b506200029a6200112d565b506200029a62001071565b506200029a62001050565b506200029a62001024565b506200029a62000f8a565b506200029a62000f60565b506200029a62000eb2565b506200029a62000e3d565b506200029a62000d50565b506200029a62000cdb565b506200029a62000c72565b506200029a62000bb1565b506200029a62000b5a565b506200029a62000a8e565b506200029a620009ba565b506200029a62000902565b506200029a6200085d565b506200029a620006ca565b6001600160a01b03811603620004d857565b600080fd5b3590620004ea82620004c6565b565b50634e487b7160e01b600052604160045260246000fd5b608081019081106001600160401b038211176200051f57604052565b62000529620004ec565b604052565b604081019081106001600160401b038211176200051f57604052565b606081019081106001600160401b038211176200051f57604052565b6001600160401b0381116200051f57604052565b60a081019081106001600160401b038211176200051f57604052565b90601f801991011681019081106001600160401b038211176200051f57604052565b6040519061016082018281106001600160401b038211176200051f57604052565b6040519060e082018281106001600160401b038211176200051f57604052565b6040519061010082018281106001600160401b038211176200051f57604052565b90620004ea604051928362000596565b6020906001600160401b03811162000644575b60051b0190565b6200064e620004ec565b6200063d565b929162000661826200062a565b9162000671604051938462000596565b829481845260208094019160051b8101928311620004d857905b828210620006995750505050565b813581529083019083016200068b565b9080601f83011215620004d857816020620006c79335910162000654565b90565b5034620004d8576060366003190112620004d857600435602435620006ef81620004c6565b6001600160401b0390604435828111620004d85762000713903690600401620006a9565b926200071e620031fb565b60008181526018602090815260408083206001600160a01b0386168452825282208651929560019392918401919083116200084d575b620007608383620034f6565b80880191875280872090875b8481106200083b57887f9f2be700e14f6c451ad8ca6a27741d1b9dd95e3200ce43f6b05015172b340dc18989620008358e620007ff620007d285620007bb866000526018602052604060002090565b9060018060a01b0316600052602052604060002090565b620007eb620007e5825463ffffffff1690565b62004cec565b63ffffffff1663ffffffff19825416179055565b620008276200081d85620007bb866000526018602052604060002090565b5463ffffffff1690565b906040519485948562004e20565b0390a180f35b8351838201559281019285016200076c565b62000857620004ec565b62000754565b5034620004d8576020366003190112620004d857602060043562000880620031fb565b80600955604051908152f35b6000910312620004d857565b60208082019080835283518092528060408094019401926000905b838210620008c357505050505090565b845180518752808401518785015280820151878301526060908101516001600160a01b03169087015260809095019493820193600190910190620008b3565b5034620004d857600080600319360112620009b757600490815481526020818152604092808484200180549262000939846200062a565b94620009488751968762000596565b8486529182528082208186015b85841062000970578751806200096c898262000898565b0390f35b84836001928a51620009828162000503565b85548152848601548382015260028601548c820152848060a01b03600387015416606082015281520192019301929062000955565b80fd5b5034620004d857600080600319360112620009b7576004548082526020828152604092839020805460018201546002830154600390930154865192835293820152938401526060830152608082015260a090f35b60031990602081830112620004d857600435916001600160401b038311620004d8578260e092030112620004d85760040190565b60005b83811062000a565750506000910152565b818101518382015260200162000a45565b9060209162000a828151809281855285808601910162000a42565b601f01601f1916010190565b5062000b4662000a9e3662000a0e565b62000aa8620034b1565b62000b3060a082013562000abe3482146200552b565b62000b1d62000b1562000b09602086013562000ada81620004c6565b604087013562000aea81620004c6565b60608801359062000afb8262000c67565b608089013592893562005646565b9460c08101906200556a565b369162001a1f565b9062000b286200559f565b9184620055c9565b9060405192839260408452604084019062000a67565b6001600160a01b0390911660208301520390f35b5034620004d8576020366003190112620004d85762000b78620031fb565b600435600c55005b6060906003190112620004d85760043562000b9b81620004c6565b9060243562000baa81620004c6565b9060443590565b5034620004d85762000bc33662000b80565b9062000bce620031fb565b6001600160a01b03908382161562000c335760405163a9059cbb60e01b60208201526001600160a01b0394909416602485015260448085019390935291835262000c27929162000c2060648462000596565b166200369e565b60405160018152602090f35b60405162461bcd60e51b815260206004820152600c60248201526b41646472657373205a65726f60a01b6044820152606490fd5b80151503620004d857565b5034620004d8576040366003190112620004d85760043562000c948162000c67565b6024359062000ca382620004c6565b62000cad620031fb565b1562000cc75762000019906001600160a01b031662004b96565b62000019906001600160a01b031662004a8e565b5034620004d8576020366003190112620004d85760043562000cfc620031fb565b62015180811062000d165780602091600555604051908152f35b60405162461bcd60e51b8152602060048201526012602482015271111d5c985d1a5bdb881d1bdbc81cda1bdc9d60721b6044820152606490fd5b5034620004d8576040366003190112620004d85760243560043562000d7582620004c6565b62000d7f620031fb565b6001600160a01b03821691821562000df857600082815260146020526040902080546001600160a01b0319166001600160a01b039092169190911790557f4289d6195cf3c2d2174adf98d0e19d4d2d08887995b99cb7b100e7ffe795820e9062000df3906040519081529081906020820190565b0390a2005b60405162461bcd60e51b815260206004820152601960248201527f5a65726f496d706c656d656e746174696f6e41646472657373000000000000006044820152606490fd5b5034620004d8576000366003190112620004d857601a546040516001600160a01b039091168152602090f35b90815180825260208080930193019160005b82811062000e8a575050505090565b83518552938101939281019260010162000e7b565b906020620006c792818152019062000e69565b5034620004d8576040366003190112620004d85760243562000ed481620004c6565b60043560005262000f0660209160188352600191829160406000209060018060a01b0316600052602052604060002090565b0191604051918282855491828152019460005282600020926000905b82821062000f4a576200096c8662000f3d818a038262000596565b6040519182918262000e9f565b8454875295860195938301939083019062000f22565b5034620004d8576000366003190112620004d857602062000f8062004ca2565b6040519015158152f35b5034620004d8576000366003190112620004d85762000fa8620031fb565b601f5460ff81161562000fe85760ff1916601f557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa6020604051338152a1005b60405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b6044820152606490fd5b5034620004d8576000366003190112620004d8576019546040516001600160a01b039091168152602090f35b5034620004d8576000366003190112620004d8576020600d54604051908152f35b5034620004d8576040366003190112620004d8576024356001600160401b038111620004d857620010a7903690600401620006a9565b33600052601e60205260ff60406000205416801562001112575b15620010d557620000199060043562004d2e565b60405162461bcd60e51b81526020600482015260156024820152744f6e6c794d61696e7461696e65724f7241626f766560581b6044820152606490fd5b50601f543360089190911c6001600160a01b031614620010c1565b5034620004d8576080366003190112620004d85760206200117b6024356200115581620004c6565b6044356200116381620004c6565b60643591620011728362000c67565b60043562004ead565b6040516001600160a01b039091168152f35b5034620004d8576020366003190112620004d857600435620011af81620004c6565b60018060a01b031660005260136020526020604060002054604051908152f35b5034620004d8576020366003190112620004d857620011ed620031fb565b600435600b55005b5034620004d857600080600319360112620009b75733600090815260136020526040902054156200124d5733815260136020908152604080832054835260148252918290205491516001600160a01b03909216825290f35b60405162461bcd60e51b81526020600482015260086024820152674e6f7450726f787960c01b6044820152606490fd5b5034620004d8576000366003190112620004d857602060ff601f54166040519015158152f35b5034620004d8576000366003190112620004d8576020600254604051908152f35b5034620004d8576020366003190112620004d857600435620012e681620004c6565b60018060a01b0316600052601c602052602060ff604060002054166040519015158152f35b5034620004d8576020366003190112620004d85760043562ffffff8116808203620004d8576020916200133d620031fb565b601d805462ffffff60a01b191660a09290921b62ffffff60a01b16919091179055604051908152f35b5034620004d85760a0366003190112620004d8576200096c6024356200138c81620004c6565b6020604435916200139d83620004c6565b606435620013ab81620004c6565b62001413608435620013bd8162000c67565b620013c762004e53565b60405191620013d6836200052e565b60018352620013e787840162004e6f565b6016546001600160a01b0316604051637cf1c11960e01b815298899788979260048035908a01620052d1565b038173__$e4e6aec0e0db0d1b1e40e2e508b0090278$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$ad9fddf5c1d7aecf165a1f59630ac9b06b$__5af494851562003cf3575b899562003ccf575b50831562003c2c575062003ba29260019262003b9062003b97936000526000602052604060002090565b01620038fd565b50019182546200362b565b90556001600160a01b038216600081815260036020526040902054909290155b62003c1a575b506040518094819363c393d0e360e01b83525af1801562003c0a575b62003bed575050565b8162003c0792903d10620017295762001719818362000596565b50565b62003c1462003317565b62003be4565b62003c259062004a7f565b3862003bc8565b62003cac9493509062003ca59162003c4362003948565b6001600160a01b0382166060820152948986015262003c948262003a508662003c76836000526000602052604060002090565b01546001600160a01b039094166000908152600e6020526040902090565b556000526000602052604060002090565b016200396f565b6001600160a01b0382166000818152600360205260409020549092901562003bc2565b62003ceb919550883d8a11620017295762001719818362000596565b933862003b66565b62003cfd62003317565b62003b5e565b9297959394505050838062003d3d8162003d338162003d2487515162003388565b5101516001600160a01b031690565b9401515162003388565b510151601a5462003d57906001600160a01b0316620016a4565b6001600160a01b03841614620040fa5762003d73818462004504565b601d5460a01c62ffffff16601a5490919062003dfc906001600160a01b03165b604051639c20e01560e01b815295869485943093928a87016001600160a01b039182168152602081019290925262ffffff9092166040820152918116606083015273e592427a0aece92de3edee1f18e0157c05861564608083015290911660a082015260c00190565b038173__$ad9fddf5c1d7aecf165a1f59630ac9b06b$__5af4908115620040ea575b600091620040c8575b505b62003e44838362003b90896000526000602052604060002090565b5062003e528282546200362b565b905562003e79600262003e6f886000526000602052604060002090565b019182546200362b565b90556002600052601760205262003ebb62003eb562003eab600160008051602062005f658339815191525b01620033c7565b90549060031b1c90565b60601c90565b600260005260176020529462003f438462003ef162003eb562003eab600160008051602062005f658339815191525b01620033f4565b60408051635abbf32960e01b81526001600160a01b03808b168883019081529b811660208d0152909216908a015273__$ad9fddf5c1d7aecf165a1f59630ac9b06b$__98909283918291606090910190565b03818a5af4908115620040b8575b60009162004096575b501562003f6a575b505050505050565b62003fd884620040249762003f8f868662003b90876000526000602052604060002090565b50906040518080958194639c1b16c560e01b83528983018154815260018201546020820152600282015460408201526003909101546001600160a01b0316606082015260800190565b03915af494851562004086575b6000956200404a575b50506200401c9260029262003b9062004011936000526000602052604060002090565b50019182546200392b565b905562004a6b565b600254156200403a575b38808080808062003f62565b620040446200489a565b6200402e565b620040119295509262003b90620040786200401c969386600297903d10620017295762001719818362000596565b969350509281945062003fee565b6200409062003317565b62003fe5565b620040b19150853d8711620017295762001719818362000596565b3862003f5a565b620040c262003317565b62003f51565b620040e39150843d8611620017295762001719818362000596565b3862003e27565b620040f462003317565b62003e1e565b91505062003e29565b60209691929493959691828101966200412162002f118951620038e5565b15620042f857505160c00151601a549651606001516001600160a01b039182166000818152601560205260409020919885931691620041bb90620041659062002ee3565b601b5460408051630abe27f760e01b81526001600160a01b039586168c820190815296861660208801529086019c909c529083166060850152919091166080830152610e1060a08301528891829160c090910190565b038173__$ad9fddf5c1d7aecf165a1f59630ac9b06b$__5af4958615620042e8575b600096620042c4575b50856003620041ff856000526000602052604060002090565b015584156200425b5750506200422b9260019262003b9062003b97936000526000602052604060002090565b90556001600160a01b038116600090815260036020526040902054155b620042505750565b620004ea9062004a7f565b62003ca592919450620042a4956200427262003948565b6001600160a01b03831660608201529586015262003c948262003a508662003c76836000526000602052604060002090565b6001600160a01b0381166000908152600360205260409020541562004248565b620042e0919650823d8411620017295762001719818362000596565b9438620041e6565b620042f262003317565b620041dd565b92959493979650505083806200431a8162003d338162003d2487515162003388565b510151601a5462004334906001600160a01b0316620016a4565b6001600160a01b03841614620044fb5762004350818462004504565b601d5460a01c62ffffff16601a5490919062004375906001600160a01b031662003d93565b038173__$ad9fddf5c1d7aecf165a1f59630ac9b06b$__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__$ad9fddf5c1d7aecf165a1f59630ac9b06b$__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__$e4e6aec0e0db0d1b1e40e2e508b0090278$__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__$e4e6aec0e0db0d1b1e40e2e508b0090278$__5af49384156200551b575b600094620054f1575b50620004ea92939460018060a01b0380961660005260136020526040600020558051906020016000f5928316151562005426565b620004ea939450620055139060203d8111620014865762001476818362000596565b9392620054bd565b6200552562003317565b620054b4565b156200553357565b60405162461bcd60e51b815260206004820152600f60248201526e57726f6e67206d73672e76616c756560881b6044820152606490fd5b903590601e1981360301821215620004d857018035906001600160401b038211620004d857602001918136038313620004d857565b60405190620055ae826200052e565b600c82526b63616c6c206661696c65642160a01b6020830152565b90929192834710620055f257600081620006c7956020839451920190855af1620036fb6200378f565b60405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6044820152651c8818d85b1b60d21b6064820152608490fd5b6040516306d3da9760e21b8152600481018290523360248201526001600160a01b03838116604483015284166064820152841515608482015290959493929190620056d09062002ee39060208160a48173__$e4e6aec0e0db0d1b1e40e2e508b0090278$__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";

type ProxyFactoryConstructorParams =
  | [linkLibraryAddresses: ProxyFactoryLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ProxyFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class ProxyFactory__factory extends ContractFactory {
  constructor(...args: ProxyFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        ProxyFactory__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: ProxyFactoryLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$e4e6aec0e0db0d1b1e40e2e508b0090278\\$__", "g"),
      linkLibraryAddresses[
        "src/aggregators/gmxV2/libraries/LibProxy.sol:LibProxy"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$ad9fddf5c1d7aecf165a1f59630ac9b06b\\$__", "g"),
      linkLibraryAddresses["src/aggregators/gmxV2/libraries/LibWin.sol:LibWin"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override getDeployTransaction(
    weth_: AddressLike,
    usdc_: AddressLike,
    liquidityPool: AddressLike,
    sequencer_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      weth_,
      usdc_,
      liquidityPool,
      sequencer_,
      overrides || {}
    );
  }
  override deploy(
    weth_: AddressLike,
    usdc_: AddressLike,
    liquidityPool: AddressLike,
    sequencer_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      weth_,
      usdc_,
      liquidityPool,
      sequencer_,
      overrides || {}
    ) as Promise<
      ProxyFactory & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): ProxyFactory__factory {
    return super.connect(runner) as ProxyFactory__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ProxyFactoryInterface {
    return new Interface(_abi) as ProxyFactoryInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ProxyFactory {
    return new Contract(address, _abi, runner) as unknown as ProxyFactory;
  }
}

export interface ProxyFactoryLibraryAddresses {
  ["src/aggregators/gmxV2/libraries/LibProxy.sol:LibProxy"]: string;
  ["src/aggregators/gmxV2/libraries/LibWin.sol:LibWin"]: string;
}
